/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Forces from '../math/Forces';

export default class SnowParticle extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._SnowFlake);

    this.mass = 1.0;
    this.gravity = 20;
    this.k = 0.0;

    this.lifetime = 2;
    this.age = 0;
    this.halflife = 0;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();

    this.leftLimit = 0;
    this.rightLimit = this.scene.scale.width;
    this.bottomLimit = this.scene.scale.height - 60;
    this.topLimit = -200;
  }

  reset (x,y,vx,vy) {
    this.pos.x = x;
    this.pos.y = y;
    this.vel.x = vx;
    this.vel.y = vy;

    this.updatePos();
  }

  adjust(gravity, nk, bl) {
    this.gravity = gravity;
    this.k = nk;
    this.bottomLimit = bl;
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
  };

  move (dt) {
    this.pos.add({ x: this.vel.x * dt, y: this.vel.y * dt });
    this.angle += this.vel.x * dt;
  }

  calcForce () {
    if (this.k === 0) {
      this.dragForce.reset();
    }
    else {
      this.dragForce.set(this.vel.x, this.vel.y);
      Forces.linearDrag(this.k, this.vel, this.dragForce);
    }
    Forces.add([this.gravityForce, this.dragForce],this.totalForce);
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt, y: this.totalForce.y * dt });
  }

  tick (dt) {
    this.move(dt);
    this.calcForce();
    this.updateAccel();
    this.updateVelocity(dt);

    if (this.pos.x < this.leftLimit || this.pos.x > this.rightLimit || this.pos.y < this.topLimit || this.pos.y > this.bottomLimit) {
      return false;
    }
    else {
      return true;
    }
  }

  updatePos () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }
}